import jpg from './delivery.jpg';
import webp from './delivery.webp';

export const delivery = [webp, jpg];
